import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react';
import { API_URL_OPTIONS, WEBSITE_URL } from '../../../config/constants';
import { WasteStream } from '../../../types/content';

// Define a service using a base URL and expected endpoints
export const websiteApi = createApi({
  reducerPath: 'websiteApi',
  baseQuery: fetchBaseQuery({ baseUrl: WEBSITE_URL }),
  endpoints: (builder) => ({
    getWasteStreams: builder.query<WasteStream[], null>({
      query: () => ({
        url: '/api/waste-streams',
        ...API_URL_OPTIONS,
      }),
    }),
  }),
});

export const { useGetWasteStreamsQuery } = websiteApi;
